export const blogCommentsData = [
    {
      key: "1",
      REVIEW:
        "Loved this list! I took the Pacific Coast Highway trip last summer, and it was breathtaking. Highly recommend renting a convertible!",
      IMAGE: "avatar-20.jpg",
      CREATEDDATE: "24 Jan 2025",
      RATING: "(5.0)",
      BLOG: "Top 10 Car Rental Tips for a Hassle-Free Journey",
      CUSTOMER: "Andrew Simons",
      STATUS: "Published",
    },
    {
      key: "2",
      REVIEW:
        "Great article! Do you have any tips on the best time of year to drive the Ring Road in Iceland?",
      IMAGE: "avatar-21.jpg",
      CREATEDDATE: "19 Dec 2024",
      RATING: "(4.0)",
      BLOG: "How to Save Money on Your Next Car Rental",
      CUSTOMER: "David Steiger",
      STATUS: "Unpublish",
    },
    {
      key: "3",
      REVIEW:
        "The Scottish Highlands road trip is on my bucket list! Any recommendations for good rental car options for those narrow roads?",
      IMAGE: "avatar-22.jpg",
      CREATEDDATE: "11 Dec 2024",
      RATING: "(5.0)",
      BLOG: "Car Rental vs. Ride-Sharing: Which One is Right for You?",
      CUSTOMER: "Walter Hartmann",
      STATUS: "Published",
    },
    {
      key: "4",
      REVIEW:
        "I did the Great Ocean Road drive last year, and it was stunning! The views, the beaches, and the wildlife—unforgettable!",
      IMAGE: "avatar-05.jpg",
      CREATEDDATE: "29 Nov 2024",
      RATING: "(3.0)",
      BLOG: "The Best Road Trip Routes to Take in a Rental Car",
      CUSTOMER: "Dennis Eckhardt",
      STATUS: "Published",
    },
    {
      key: "5",
      REVIEW:
        "Iceland’s Ring Road sounds amazing! Is a 4x4 necessary, or can I manage with a regular rental car?",
      IMAGE: "avatar-24.jpg",
      CREATEDDATE: "03 Nov 2024",
      RATING: "(4.0)",
      BLOG: "Step-by-Step Guide to Booking a Rental Car Online",
      CUSTOMER: "Virginia Phu",
      STATUS: "Published",
    },
    {
      key: "6",
      REVIEW:
        "Just booked my rental car for a road trip next month! Can't wait to explore new places. Thanks for the inspiration!",
      IMAGE: "avatar-25.jpg",
      CREATEDDATE: "31 Oct 2024",
      RATING: "(5.0)",
      BLOG: "What You Need to Know About Rental Car Insurance",
      CUSTOMER: "Lan Adams",
      STATUS: "Unpublish",
    },
    {
      key: "7",
      REVIEW:
        "Fantastic suggestions! I'd love to see a follow-up post on hidden road trip gems that aren't as well known.",
      IMAGE: "avatar-10.jpg",
      CREATEDDATE: "15 Oct 2024",
      RATING: "(3.0)",
      BLOG: "Returning a Rental Car: Common Mistakes to Avoid",
      CUSTOMER: "Ann Crump",
      STATUS: "Unpublish",
    },
    {
      key: "8",
      REVIEW:
        "Are there any scenic road trips in Europe you'd recommend that aren't as crowded with tourists?",
      IMAGE: "avatar-26.jpg",
      CREATEDDATE: "26 Sep 2024",
      RATING: "(5.0)",
      BLOG: "How to Find the Best Car Rental Deals & Discounts",
      CUSTOMER: "Andrea Jermaine",
      STATUS: "Published",
    },
    {
      key: "9",
      REVIEW:
        "I’ve always wanted to do a cross-country road trip in the U.S.! Any tips on choosing the best rental car for long-distance travel?",
      IMAGE: "avatar-23.jpg",
      CREATEDDATE: "01 Sep 2024",
      RATING: "(4.0)",
      BLOG: "Luxury Car Rentals: Are They Worth the Price?",
      CUSTOMER: "Julie Black",
      STATUS: "Published",
    },
    {
      key: "10",
      REVIEW:
        "This article makes me want to pack my bags and go! Road trips are the best way to travel. Thanks for the great ideas!",
      IMAGE: "avatar-16.jpg",
      CREATEDDATE: "15 Aug 2024",
      RATING: "(3.0)",
      BLOG: "Short-Term vs. Long-Term Car Rentals: Which Saves More?",
      CUSTOMER: "Jean Walker",
      STATUS: "Published",
    },
];